import axios from "./request";
import { Log } from "./log";
import { getValidationContent } from "../utils";
const getLocalUserInfo = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user || {};
};
export const AddMessage = params => {
  const {
    title,
    type,
    content,
    m_type,
    file,
    sd_type,
    resource_type,
    name,
    m_facturer,
    price,
    platform,
    img,
    file_type,
    xq_type,
    reject_cause,
    status,
    page_view,
    is_admin,
    pid,
    theme
  } = params;
  const data = new FormData();
  const { id: uid } = getLocalUserInfo();
  if (is_admin) {
    Log(`添加了${m_type},${title || name}`);
  }
  data.append("uid", uid);
  data.append("m_type", m_type || "");
  // data.append('reject_cause', reject_cause || '')
  if (m_type != "6") {
    data.append(
      "status",
      status && String(status) && String(status) !== "undefined" ? status : "2"
    );
  }
  if (m_type != "5") {
    data.append("title", title.trim());
  }
  if (m_type == "6") {
    data.append("theme", theme);
    data.append("pid", pid);
  }
  if (m_type != "2" && m_type != "6") {
    data.append("content", content || "");
    const {
      validateImgs,
      validateVideos,
      validateContent
    } = getValidationContent(content);
    data.append("validateImgs", validateImgs || "");
    data.append("validateVideos", validateVideos || "");
    data.append("validateContent", validateContent || "");
  }
  if (m_type == "1" || m_type == "2") {
    data.append("type", type);
  }
  if (m_type == "4") {
    data.append("xq_type", xq_type);
  }
  if (m_type == "3") {
    data.append("resource_type", resource_type);
    data.append("sd_type", sd_type);
  }
  if (m_type == "2" || m_type == "5") {
    data.append("file", file && file[0] ? file[0].url : "");
  }
  if (page_view) {
    data.append("page_view", page_view);
  }
  if (m_type == "5") {
    data.append("file_type", file_type);
    data.append("platform", platform);
    data.append("name", name.trim());
    data.append("m_facturer", m_facturer || "");
    data.append("price", price || 0);
    if (img && img.length) {
      for (let i = 0; i < img.length; i++) {
        const item = img[i];
        data.append("img[]", item.url);
      }
    } else {
      data.append("img[]", "");
    }
  }
  return axios.post("/add_message", data);
};
export const GetMessageList = params => {
  const { id: uid } = getLocalUserInfo();
  const { page, m_type, title, status } = params;
  const data = new FormData();
  data.append("page", page);
  data.append("m_type", m_type);
  data.append("status", status || "");
  if (m_type == "5") {
    data.append("name", title || "");
    data.append("title", "");
  } else {
    data.append("name", "");
    data.append("title", title || "");
  }
  data.append("uid", m_type != "7" && m_type != "6" ? uid : "");
  data.append("is_user", "");
  data.append("is_admin", "");
  data.append("num", "10");
  return axios.post("/select_message", data);
};

export const GetAllUserMessageList = params => {
  const { id: uid } = getLocalUserInfo();
  const { page, m_type, title, status } = params;
  const data = new FormData();
  data.append("page", page);
  data.append("m_type", m_type);
  data.append("status", status || "");
  if (m_type == "5") {
    data.append("name", title || "");
    data.append("title", "");
  } else {
    data.append("title", title || "");
  }
  data.append("uid", uid);
  data.append("is_admin", "2");
  data.append("is_user", "1");
  data.append("num", "10");
  return axios.post("/select_message", data);
};
export const GetMessageDetail = params => {
  const { id, m_type } = params;
  const data = new FormData();
  const { id: uid } = getLocalUserInfo();
  data.append("id", id);
  data.append("m_type", m_type);
  if (m_type == 7) {
    data.append("uid", uid);
  }
  return axios.post("/message_delail", data);
};
export const DeleteMessage = params => {
  const { id, m_type, is_admin } = params;
  const data = new FormData();
  data.append("id", id);
  data.append("m_type", m_type);
  if (is_admin) {
    Log(`删除了发布,id为${id}`);
  }
  return axios.post("/del_message", data);
};
export const PutawayMessage = params => {
  const { id, m_type, status, is_admin } = params;
  const data = new FormData();
  data.append("id", id);
  data.append("m_type", m_type);
  data.append("status", status);
  const { id: uid } = getLocalUserInfo();
  if (is_admin) {
    data.append("uid", uid);
    Log(`${status ? "上架" : "下架"}了发布,id为${id}`);
  } else {
    data.append("uid", "");
  }
  return axios.post("/putaway", data);
};
export const RejectMessage = params => {
  const { id, m_type, reject_cause } = params;
  const data = new FormData();
  data.append("id", id);
  data.append("m_type", m_type);
  data.append("reject_cause", reject_cause);
  Log(`驳回了发布,id为${id}`);
  return axios.post("/reject", data);
};
export const UpdateMessage = params => {
  const {
    id,
    title,
    type,
    content,
    m_type,
    file,
    sd_type,
    resource_type,
    name,
    m_facturer,
    price,
    platform,
    img,
    file_type,
    xq_type,
    reject_cause,
    page_view,
    is_admin,
    theme,
    pid
  } = params;
  const data = new FormData();
  const { id: uid } = getLocalUserInfo();
  data.append("uid", uid);
  data.append("id", id);
  data.append("m_type", m_type);
  // data.append('reject_cause', reject_cause)
  if (is_admin) {
    Log(`修改了${m_type},${title || name},id为${id}`);
  }
  if (page_view) {
    data.append("page_view", page_view);
  }
  if (m_type != "5") {
    data.append("title", title.trim());
  }
  if (m_type == "6") {
    data.append("theme", theme);
    data.append("pid", pid);
  }
  if (m_type != "2" && m_type != "6") {
    data.append("content", content || "");
    const {
      validateImgs,
      validateVideos,
      validateContent
    } = getValidationContent(content);
    data.append("validateImgs", validateImgs || "");
    data.append("validateVideos", validateVideos || "");
    data.append("validateContent", validateContent || "");
  }
  if (m_type == "1" || m_type == "2") {
    data.append("type", type);
  }
  if (m_type == "4") {
    data.append("xq_type", xq_type);
  }
  if (m_type == "3") {
    data.append("resource_type", resource_type);
    data.append("sd_type", sd_type);
  }
  if (m_type == "2" || m_type == "5") {
    data.append("file", file && file[0] ? file[0].url : "");
  }
  if (m_type == "5") {
    data.append("file_type", file_type);
    data.append("platform", platform);
    data.append("name", name.trim());
    data.append("m_facturer", m_facturer);
    data.append("price", price);
    if (img && img.length) {
      for (let i = 0; i < img.length; i++) {
        const item = img[i];
        data.append("img[]", item.url);
      }
    } else {
      data.append("img[]", "");
    }
  }
  return axios.post("/up_message", data);
};

export const AddProject = params => {
  const {
    introduce,
    start_time,
    file,
    is_admin,
    page_view,
    end_time,
    status,
    title
  } = params;
  const data = new FormData();
  const { id: uid } = getLocalUserInfo();
  data.append("uid", uid);
  data.append("m_type", "7");
  data.append(
    "status",
    status && String(status) && String(status) !== "undefined" ? status : "2"
  );
  if (is_admin) {
    Log(`添加了项目,${title}`);
  }
  if (page_view) {
    data.append("page_view", page_view);
  }
  data.append("start_time", start_time + " 00:00:01");
  data.append("end_time", end_time + " 23:59:59");
  data.append("file", file && file[0] ? file[0].url : "");
  data.append("title", title.trim());
  data.append("introduce", introduce || "");
  return axios.post("/add_message", data);
};

export const EditProject = params => {
  const {
    introduce,
    start_time,
    file,
    is_admin,
    page_view,
    end_time,
    title,
    id
  } = params;
  const data = new FormData();
  const { id: uid } = getLocalUserInfo();
  data.append("uid", uid);
  data.append("id", id);
  data.append("m_type", "7");
  if (is_admin) {
    Log(`修改了项目,${title},id为${id}`);
  }
  if (page_view) {
    data.append("page_view", page_view);
  }
  data.append("start_time", start_time + " 00:00:01");
  data.append("end_time", end_time + " 23:59:59");
  data.append("file", file && file[0] ? file[0].url : "");
  data.append("title", title.trim());
  data.append("introduce", introduce || "");
  data.append("id", id);
  return axios.post("/up_message", data);
};

export const GetProjectList = params => {
  //查看申请or咨询表or政策解读表
  const {
    page,
    is_project,
    name,
    status,
    title,
    file,
    num,
    uid,
    is_admin
  } = params;
  const data = new FormData();
  data.append("page", page);
  data.append("is_admin", is_admin || 1);
  data.append("is_project", is_project);
  data.append("status", status || "");
  if (is_project == 3) {
    data.append("title", title || "");
    data.append("name", name || "");
    data.append("project_name", "");
  } else {
    data.append("title", "");
    data.append("name", "");
    data.append("project_name", name || title);
  }
  if (is_project == 1) {
    data.append("file_name", file || "");
  }
  data.append("uid", uid || "");
  data.append("num", num || "10");
  return axios.post("/select_project_classify", data);
};
export const DeleteProjects = params => {
  const { id, is_project, is_admin } = params;
  let project_type = () => {
    if (is_project == 1) return "申报预审";
    if (is_project == 2) return "项目咨询";
    if (is_project == 3) return "政策解读";
  };
  const data = new FormData();
  data.append("id", id);
  data.append("is_project", is_project);

  if (is_admin) {
    Log(`删除了${project_type()},id为${id}`);
  }
  return axios.post("/del_project_classify", data);
};

export const AddProjects = params => {
  const { id: uid } = getLocalUserInfo();
  const {
    is_project,
    is_admin,
    phone,
    status,
    poid,
    file,
    title,
    content,
    page_view,
    file_name
  } = params;
  let project_type = () => {
    if (is_project == 1) return "申报预审";
    if (is_project == 2) return "项目咨询";
    if (is_project == 3) return "政策解读";
  };
  const data = new FormData();
  data.append("is_project", is_project);
  data.append("uid", uid);
  data.append("page_view", page_view);
  if (is_project != 3) {
    data.append("phone", phone);
    data.append("status", status);
    data.append("poid", poid);
  }
  if (is_project == 1) {
    data.append("file", file && file[0] ? file[0].url : "");
    data.append("file_name", file_name);
  }

  if (is_project == 3) {
    data.append("title", title);
    data.append("content", content);
  }
  if (is_admin) {
    Log(`添加了${project_type()}`);
  }
  return axios.post("/add_project_classify", data);
};

export const EditProjects = params => {
  const {
    is_project,
    is_admin,
    phone,
    status,
    poid,
    file,
    title,
    content,
    id,
    page_view,
    file_name
  } = params;
  let project_type = () => {
    if (is_project == 1) return "申报预审";
    if (is_project == 2) return "项目咨询";
    if (is_project == 3) return "政策解读";
  };
  const data = new FormData();
  data.append("is_project", is_project);
  data.append("id", id);
  data.append("page_view", page_view);
  if (is_project != 3) {
    data.append("phone", phone);
    data.append("status", status);
    data.append("poid", poid);
  }
  if (is_project == 1) {
    data.append("file", file && file[0] ? file[0].url : "");
    data.append("file_name", file_name);
    data.append("audit_id", uid);
  }

  if (is_project == 3) {
    data.append("title", title);
    data.append("content", content);
  }

  if (is_admin) {
    Log(`更新了${project_type()},id为${id}`);
  }
  return axios.post("/up_project_classify", data);
};

export const GetProjectDetail = params => {
  const { id, is_project } = params;
  const data = new FormData();
  data.append("id", id);
  data.append("is_project", is_project);
  return axios.post("/detail_project_classify", data);
};

export const PutAwayProject = params => {
  const { id, is_project, status, subscribed_at } = params;
  const { id: uid } = getLocalUserInfo();
  const data = new FormData();
  data.append("id", id);
  data.append("is_project", is_project);
  data.append("status", status);
  if (is_project == 1 && status == 1) {
    data.append("audit_id", uid);
  }
  if (is_project == 2 && status == 1) {
    data.append("affirm_id", uid);
  }
  if (subscribed_at) {
    data.append("subscribed_at", subscribed_at);
  }
  return axios.post("/up_project_classify", data);
};
export const RejectProject = params => {
  const { id, reject_cause } = params;
  const data = new FormData();
  data.append("id", id);
  data.append("is_project", 1);
  data.append("status", 2);
  data.append("reject_cause", reject_cause);
  return axios.post("/up_project_classify", data);
};

export const SendSMSTemplate = params => {
  const { phone, project_name } = params;
  const data = new FormData();
  data.append("phone", phone);
  data.append("project_name", project_name);
  return axios.post("/sendSMSTemplate", data);
};

export const GetProjectFile = params => {
  const { time_sort, project_sort, page, project_id } = params;
  const data = new FormData();
  data.append("time_sort", time_sort);
  data.append("project_sort", project_sort);
  data.append("page", page);
  data.append("project_id", project_id || "");
  data.append("num", 12);

  return axios.post("/project_file", data);
};



// WEBPACK FOOTER //
// ./src/request/adminRelease.js